// extracted by mini-css-extract-plugin
export var addButton = "_fj-0";
export var border = "_fj-8";
export var check = "_fj-h";
export var danger = "_fj-6";
export var dropdownContainer = "_fj-1";
export var editModalBody = "_fj-j";
export var footerContainer = "_fj-i";
export var fullWidth = "_fj-a";
export var hide = "_fj-9";
export var icon = "_fj-3";
export var input = "_fj-7";
export var inputFlex = "_fj-b";
export var inputWrapper = "_fj-c";
export var manualFocus = "_fj-5";
export var optionButton = "_fj-4";
export var pillWrapper = "_fj-e";
export var pointer = "_fj-2";
export var showOverflow = "_fj-f";
export var tagsFlex = "_fj-d";
export var xButton = "_fj-g";